// Lazy load function
const lazyLoad = (file) => () =>
  import(
    /* webpackChunkName: "[request]" */ `@/views/inventory/stock-take/${file}.vue`
  );

export default [
  {
    path: "/stock-take-prepare/create",
    name: "stock-take-prepare-create",
    meta: { requiresAuth: true, applicationFeatureCode: "StocktakeCount" },
    components: {
      content: lazyLoad("prepare"),
    },
  },
  {
    path: "/stock-take-prepare/review/:id",
    name: "stock-take-prepare-review",
    meta: { requiresAuth: true, applicationFeatureCode: "StocktakeCount" },
    components: {
      content: lazyLoad("prepare"),
    },
  },
  {
    path: "/stock-take-count/edit/:id",
    name: "stock-take-count-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: ["StocktakeCount", "StocktakeManagement"],
    },
    components: {
      content: lazyLoad("count"),
    },
  },
  {
    path: "/stock-take-count/review/:id",
    name: "stock-take-count-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "StocktakeCount",
    },
    components: {
      content: lazyLoad("count"),
    },
  },
  {
    path: "/stock-take-review/review/:id",
    name: "stock-take-review-review",
    meta: { requiresAuth: true, applicationFeatureCode: "StocktakeCount" },
    components: {
      content: lazyLoad("review"),
    },
  },
];
